import axios from "axios";
import {saveSingleEndPointLogAPI} from "../api/singleEndPointLog"
import {
  AppAdtopiaToken,
  AppPostCodeSingleApi,
  AppEmailValidateSingleApi,
  AppApiUrl,
  AppSinglePointPhoneValidationURL,
  AppBudsSingleApi,
  AppGmailWebhookApi,
  AppAdtopiaUPID,
  AppEnv
} from "../Constants/EnvConstants";

require("dotenv").config();

export const Api = axios.create({
  baseURL: AppApiUrl,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken,
  },
});

export const CommonEndApi = axios.create({
  baseURL: AppPostCodeSingleApi,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken
  }
});

export const CommonEmailValidateApi = axios.create({
  baseURL: AppEmailValidateSingleApi,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken
  }
});

export const IdUploadApi = axios.create({
  baseURL: AppApiUrl,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken,
  },
});

export const CommonPhoneValidation = axios.create({
  baseURL: AppSinglePointPhoneValidationURL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken
  }
});

export const BudsApi = axios.create({
  baseURL: AppBudsSingleApi,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken
  }
});

export const GmailWebhookApi = axios.create({
  baseURL: AppGmailWebhookApi,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

export const RedshiftApi = axios.create({
  baseURL: AppApiUrl,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken,
  },
});
/**
 * Apply Interceptor
 */
const applyInterceptors = (instance) => {
  instance.interceptors.response.use(
    async (response) => {
      try {
        let requestData = {};

        try {
          requestData = JSON.parse(
            response.config?.data || "{}"
          );
        } catch {
          requestData = response.config?.data || {};
        }

        if (
          !response.config?.baseURL?.startsWith(
            "https://chat.googleapis"
          )
        ) {
          await saveSingleEndPointLogAPI({
            ProjectCode: AppAdtopiaUPID,
            Environment: AppEnv,
            request: requestData,
            url: response.config?.url,
            baseURL: response.config?.baseURL,
            response: response.data,
            statusCode: response.status,
          });
        }
      } catch (logError) {
        console.error(
          "Failed to save API log:",
          logError?.message
        );
      }

      return response;
    },

    async (error) => {
      try {
        let requestData = {};

        try {
          requestData = JSON.parse(
            error.config?.data || "{}"
          );
        } catch {
          requestData = error.config?.data || {};
        }

        if (
          !error.config?.baseURL?.startsWith(
            "https://chat.googleapis"
          )
        ) {
          await saveSingleEndPointLogAPI({
            ProjectCode: AppAdtopiaUPID,
            Environment: AppEnv,
            request: requestData,
            url: error.config?.url,
            baseURL: error.config?.baseURL,
            response: {
              errorMessage: error.message,
              statusCode: error.response?.status,
              data: error.response?.data,
              errorCode: error.code,
            },
          });
        }
      } catch (logError) {
        console.error(
          "Failed to save API error log:",
          logError?.message
        );
      }
      return Promise.reject(error);
    }
  );
};
/**
 * Apply Interceptors
 */
applyInterceptors(Api);
applyInterceptors(CommonEndApi);
applyInterceptors(CommonEmailValidateApi);
applyInterceptors(CommonPhoneValidation);
applyInterceptors(IdUploadApi);
